import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Events } from './events.actions';
import { catchError, map, of, switchMap } from 'rxjs';
import { EventsService } from '@careapp-group/ng-sdk';
import { Injectable } from '@angular/core';

@Injectable()
export class EventsEffects {
  getEventsForMember$ = createEffect(() =>
    this.actions$.pipe(
      ofType(Events.RequestAllForSegmentAction),
      switchMap((action) =>
        this.api
          .getMemberActivity({
            memberId: action.segment,
            limit: action.filter?.limit,
            skip: action.filter?.skip,
          })
          .pipe(
            map((result) =>
              Events.ResponseSuccessAllForSegmentAction({
                items: result,
                segment: action.segment,
                filter: action.filter,
              }),
            ),
            catchError((res) =>
              of(
                Events.ResponseFailAllForSegmentAction({
                  error: res,
                  segment: action.segment,
                }),
              ),
            ),
          ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private api: EventsService,
  ) {}
}
